import { ref } from 'vue';


const default_timeout = 7;
const types = [ 'default', 'success', 'info', 'warning', 'error' ];


let auto_id = 0;
let items = ref( [] );


function Dismiss ( item )
{
	let found = false;
	
	items.value.forEach( ( notification_item, index ) =>
	{
		if ( notification_item === item )
			found = index;
	} );
	
	if ( found !== false )
		items.value.splice( found, 1 );
}


function Do_action ( action )
{
	try
	{
		action.fn( ...action.params );
	}
	catch ( e ) {}
}


export function Get_items ()
{
	return items;
}


export function Clear ()
{
	items.value = [];
}


export function Delete_first ()
{
	items.value.splice( 0, 1 );
}


export function Add ( message, options )
{
	let effective_timeout = default_timeout;
	let proposed_timeout = Math.floor( Math.abs( parseInt( options?.timeout ) ) );
	
	if ( proposed_timeout > 0 )
		effective_timeout = proposed_timeout;
	
	let curated_actions = [];
	
	if ( options?.actions && ( options.actions instanceof Array ) )
	{
		options.actions.forEach( action =>
		{
			if ( !action.label || !action?.fn || !( action.fn instanceof Function ) )
				return;
			
			if ( !action?.params || !( action.params instanceof Array ) )
				action.params = [];
			
			curated_actions.push( action );
		} );
	}
	
	let item =
	{
		message: message,
		type: types.includes( options?.type ) ? options.type : 'info',
		timeout: effective_timeout,
		actions: curated_actions,
		dismiss: () => Dismiss( item )
	};
	
	items.value.push( item );
}


export function Message ( message, actions = [], timeout = default_timeout )
{
	Add( message, { type: 'default', timeout: timeout, actions: actions } );
}


export function Success ( message, actions = [], timeout = default_timeout )
{
	Add( message, { type: 'success', timeout: timeout, actions: actions } );
}


export function Info ( message, actions = [], timeout = default_timeout )
{
	Add( message, { type: 'info', timeout: timeout, actions: actions } );
}


export function Warning ( message, actions = [], timeout = default_timeout )
{
	Add( message, { type: 'warning', timeout: timeout, actions: actions } );
}


export function Error ( message, actions = [], timeout = default_timeout )
{
	Add( message, { type: 'error', timeout: timeout, actions: actions } );
}
